module.exports = __webpack_public_path__ + "img/logo2.053378a9.png";